import React from 'react';

export const activeSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 13V10L0 3V1H16V3L10 10V16L6 13Z" fill="#404040" />
  </svg>
);

export const activeSVGString = `<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 13V10L0 3V1H16V3L10 10V16L6 13Z" fill="#404040" />
  </svg>`;
